import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { ADD_UPDATE_GROUP, BASE_URL, GET_COMPANY_GROUP_PEOPLE } from "../constants";
import { getUserToken } from "../utilityFunctions/localServices";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";

export const manageGroupsCompany = createApi({
  reducerPath: "companyGroup",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchGroupsTableData: builder.query({
      query: ({ token, pagination, orggrp_id, company_id }) => {
        const params = new URLSearchParams(pagination);

        //const url = `${GET_COMPANY_GROUP_PEOPLE}/5?${params.toString()}`;
        const url = `${GET_COMPANY_GROUP_PEOPLE}/${company_id}?${params.toString()}`;
        //const url = `${GET_COMPANY_GROUP_PEOPLE}?${params.toString()}&company_id=${orggrp_id}`;

        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
  endpoints: (builder) => ({
    groupAddUpdateNode: builder.mutation({
      query: ({ token, data }) => ({
        url: ADD_UPDATE_GROUP,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token || getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
      invalidatesTags: ["GroupData"],
    }),
  }),
});

export const { useFetchGroupsTableDataQuery, useGroupAddUpdateNodeMutation } = manageGroupsCompany;
